// ADVENTUR — 26 tools in 4 blocks. Marker positions are card millimetres (mx from the face's
// left edge, my from its top); est:true = my authored guess, replaced the moment a mark is placed.
// hom = photo% -> card fraction, fitted against the STL silhouette (front 0.73 vs 0.52 mirrored,
// back 0.95 vs 0.80) — the same test also proves which photo shows which face.
window.ADV = {
 "hom": {
  "A": [[0.01841507, -0.00760435, -0.00553759], [0.01878806, 0.01731803, -1.298702], [0.00474021, -0.00067946, 1]],
  "B": [[0.01326862, 0.00095855, -0.14594195], [-0.00057193, 0.0186283, -0.62021983], [-0.00042434, 0.00119, 1]]
 },
 "photo": {
  "A": "https://mrf.tools/cdn/shop/files/mrf26-adv-photo-a.jpg?v=b3",
  "B": "https://mrf.tools/cdn/shop/files/mrf26-adv-photo-b.jpg?v=b3"
 },
 "blocks": [
  {
   "name": "Cut & camp",
   "tools": [
    {
     "n": 4,
     "cat": "CUT",
     "side": "A",
     "mx": 0,
     "my": 32.5,
     "est": false,
     "name": "Axe",
     "desc": "The curved left edge is ground as a chopping bit — with the arrow lashed to a shaft it becomes a working hatchet.",
     "sc": "Splitting kindling at camp with a stick and a length of cord."
    },
    {
     "n": 7,
     "cat": "CUT",
     "side": "A",
     "mx": 30,
     "my": 52,
     "est": true,
     "name": "Knife",
     "desc": "Long straight edge on the bottom, 440C at 52–54 HRC — the blade you actually cut with.",
     "sc": "Cutting rope, tape and dinner on a trip."
    },
    {
     "n": 5,
     "cat": "CUT",
     "side": "A",
     "mx": 0,
     "my": 49.1,
     "est": false,
     "name": "Scraper",
     "desc": "Blunt ground back edge for scraping — paint, gasket, frozen crust — without touching the knife edge.",
     "sc": "Cleaning a gasket face before it goes back together."
    },
    {
     "n": 6,
     "cat": "CAMP",
     "side": "A",
     "mx": 0,
     "my": 16.8,
     "est": false,
     "name": "Shovel",
     "desc": "The wedge corner digs: a trowel for a fire pit, a tent peg hole or a cathole.",
     "sc": "Digging a fire pit where the ground is packed."
    },
    {
     "n": 25,
     "cat": "CUT",
     "side": "B",
     "mx": 44.7,
     "my": 48.6,
     "est": false,
     "name": "Cord cutter",
     "desc": "Hooked notch that catches cord and cuts it as you pull — safer than a naked edge in a moving hand.",
     "sc": "Cutting paracord mid-knot without unpacking a knife."
    },
    {
     "n": 15,
     "cat": "CAMP",
     "side": "B",
     "mx": 41.6,
     "my": 55,
     "est": false,
     "name": "Bottle opener",
     "desc": "Marked cap lifter on the bottom edge, sized so the card doesn't twist in your fingers.",
     "sc": "The end of a long day on the trail."
    },
    {
     "n": 26,
     "cat": "CAMP",
     "side": "B",
     "mx": 82.2,
     "my": 55,
     "est": false,
     "name": "Can opener",
     "desc": "Stepped hook that walks a tin lid open — slow, but it always works.",
     "sc": "Opening a tin when the pull-ring tears off."
    }
   ],
   "id": "camp",
   "label": "Cut & camp",
   "sub": "Axe, knife, shovel, openers"
  },
  {
   "name": "Navigate & arrow",
   "tools": [
    {
     "n": 23,
     "cat": "NAVIGATE",
     "side": "B",
     "mx": 35.5,
     "my": 8.2,
     "est": false,
     "name": "Sundial compass",
     "desc": "Engraved rose with N-E-S-W around the gnomon hole: set it by the sun and you have bearings without a needle.",
     "sc": "Getting your bearings on a ridge with a dead phone."
    },
    {
     "n": 24,
     "cat": "NAVIGATE",
     "side": "B",
     "mx": 76,
     "my": 30.9,
     "est": false,
     "name": "Sundial clock",
     "desc": "Hour lines from 6 to 18 with the North/South 12:00 axis — stand a match in the hole and read the time off the shadow.",
     "sc": "Telling the hour on day three with no battery left."
    },
    {
     "n": 19,
     "cat": "ARROW",
     "side": "A",
     "mx": 20.7,
     "my": 27.6,
     "est": false,
     "part": "arrow",
     "name": "Arrow head",
     "desc": "Broadhead point with the socket end sized for a standard shaft — the reason the card has a window in the middle.",
     "sc": "Fitting a point to a shaft you cut yourself."
    },
    {
     "n": 20,
     "cat": "ARROW",
     "side": "A",
     "mx": 27.1,
     "my": 27.6,
     "est": false,
     "part": "arrow",
     "name": "Spear head",
     "desc": "The same blank lashed to a pole becomes a spear: the triangular cut-out is where the cord bites.",
     "sc": "Making a reach tool out of a sapling."
    },
    {
     "n": 21,
     "cat": "ARROW",
     "side": "A",
     "mx": 33.8,
     "my": 27.6,
     "est": false,
     "part": "arrow",
     "name": "Tomahawk",
     "desc": "Side edge of the arrow, ground for chopping — mounted crosswise on a shaft it swings like a small axe.",
     "sc": "Clearing brush without carrying an axe."
    },
    {
     "n": 13,
     "cat": "SYSTEM",
     "side": "B",
     "mx": 12.9,
     "my": 33.6,
     "est": false,
     "name": "Lock system",
     "desc": "The window and its shoulder hold the arrow in place: it drops in, twists home and rides flat in a wallet.",
     "sc": "Carrying the point without it rattling loose in a pack."
    }
   ],
   "id": "hunt",
   "label": "Hunt & navigate",
   "sub": "Heads, sun, lock"
  },
  {
   "name": "Wrench & drive",
   "tools": [
    {
     "n": 10,
     "cat": "WRENCH",
     "side": "B",
     "mx": 60.2,
     "my": 18.9,
     "est": false,
     "name": "17 mm, 15 mm, 11/16\", 9/16\" wrench",
     "desc": "The stepped edge along the arrow window: four sizes cut as a staircase so the card fits the nut at whichever step is free.",
     "sc": "Roadside repair where every fastener is a different size."
    },
    {
     "n": 18,
     "cat": "WRENCH",
     "side": "A",
     "mx": 71.9,
     "my": 44.2,
     "est": false,
     "name": "5/16\", 3/8\", 10 mm wrench",
     "desc": "Small-size block at the bottom right — the sizes that turn up on bike, boat and furniture hardware.",
     "sc": "Tightening a rack bolt on a loaded bike."
    },
    {
     "n": 11,
     "cat": "WRENCH",
     "side": "B",
     "mx": 37,
     "my": 27.8,
     "est": false,
     "name": "1/2\" gas valve wrench",
     "desc": "Square opening for the ½\" gas valve stem — the one fitting a normal wrench never fits.",
     "sc": "Turning a stubborn valve on a camp gas bottle."
    },
    {
     "n": 14,
     "cat": "WRENCH",
     "side": "B",
     "mx": 11.2,
     "my": 44.8,
     "est": false,
     "name": "O₂ wrench",
     "desc": "The oxygen-bottle spanner that welders and divers keep asking for, cut into the bottom corner.",
     "sc": "Bottle swap at a workshop where the proper key has walked off."
    },
    {
     "n": 9,
     "cat": "WRENCH",
     "side": "B",
     "mx": 7.6,
     "my": 8.4,
     "est": false,
     "name": "Arrow wrench",
     "desc": "Six-pointed socket that grips the arrow head itself, so the point can be screwed onto a shaft hand-tight.",
     "sc": "Fitting the arrow to a shaft in the field."
    },
    {
     "n": 17,
     "cat": "DRIVE",
     "side": "A",
     "mx": 65,
     "my": 11.5,
     "est": false,
     "name": "1/4\" bit driver",
     "desc": "Hex socket for a standard ¼\" bit — the card becomes the handle.",
     "sc": "Driving a screw with a loose bit from a workshop drawer."
    },
    {
     "n": 8,
     "cat": "DRIVE",
     "side": "A",
     "mx": 83.7,
     "my": 28.1,
     "est": false,
     "part": "arrow",
     "name": "Flat screwdriver",
     "desc": "The arrow's tail is ground to a flat blade — a real screwdriver once the arrow is out of the card.",
     "sc": "Opening a battery hatch at camp."
    },
    {
     "n": 16,
     "cat": "WRENCH",
     "side": "B",
     "mx": 0,
     "my": 32.9,
     "est": false,
     "name": "Wrench 1/2\", 7/16\", 8 mm",
     "desc": "Three sizes in one staircase — imperial 1/2\" and 7/16\" beside metric 8 mm.",
     "sc": "A 7/16\" nut on a bow sight, tightened in the field."
    }
   ],
   "id": "wrench",
   "label": "Wrench & drive",
   "sub": "Nuts, valves, bits"
  },
  {
   "name": "Measure & mark",
   "tools": [
    {
     "n": 1,
     "cat": "MEASURE",
     "side": "A",
     "mx": 35.1,
     "my": 0,
     "est": false,
     "name": "Metric ruler",
     "desc": "70 mm scale along the top edge, millimetre ticks cut through the edge so you read against the work, not next to it.",
     "sc": "Sizing a bolt at a hardware counter without guessing."
    },
    {
     "n": 22,
     "cat": "MEASURE",
     "side": "B",
     "mx": 53.1,
     "my": 0,
     "est": false,
     "name": "Inch ruler",
     "desc": "The back edge carries the imperial scale — 0 to 2½\" in halves and quarters.",
     "sc": "Reading an imperial drawing on a job that ships to the States."
    },
    {
     "n": 3,
     "cat": "MEASURE",
     "side": "A",
     "mx": 54.3,
     "my": 29.2,
     "est": false,
     "name": "Protractor",
     "desc": "80° to 180° arc laid around the arrow window: hold the card against a joint and read the angle straight off the fan.",
     "sc": "Checking a rafter angle before the cut."
    },
    {
     "n": 12,
     "cat": "MEASURE",
     "side": "B",
     "mx": 5.4,
     "my": 20.4,
     "est": false,
     "name": "Distance ruler",
     "desc": "Rangefinder scale: hold the card at arm's length, match a figure to the marks and read 40 to 200 m off the ladder.",
     "sc": "Estimating the distance to a treeline before setting off."
    },
    {
     "n": 2,
     "cat": "MEASURE",
     "side": "A",
     "mx": 29.9,
     "my": 6.8,
     "est": false,
     "name": "Wire bender",
     "desc": "Three keyed slots at the top edge for bending wire to a repeatable radius instead of by eye.",
     "sc": "Bending a hook out of fence wire to hang a lamp."
    }
   ],
   "id": "measure",
   "label": "Measure & draw",
   "sub": "Rulers, angles, wire"
  }
 ]
};
